class CreateChatSessionResult {

    Id: number;

    constructor(id: number) {
        this.Id = id;
    }
}

export default CreateChatSessionResult;
